module.exports = __webpack_public_path__ + "static/media/SF-13-A.52e0b697.mp3";